module.exports = __webpack_public_path__ + "img/dots3.68af2bad.svg";